import React, { useState, useEffect } from 'react';
import { colorTheme } from 'theme';
import { Box, Tabs, Tab, useTheme, Typography } from '@mui/material';
import { type ITabPanelProps } from 'types';
import UserPlanChangeRequests from './userPlanRequests';
import UserWithdrawalRequests from './userWithdrawalRequests';
import { strings } from 'i18n/Strings';
import { useParams } from 'react-router-dom';
import { getUserPlan } from 'service';

function TabPanel(props: ITabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box pb={2}>{children}</Box>}
    </div>
  );
}

const PlanDetails = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const { id } = useParams();

  const [tab, setTab] = useState(0);
  const [userPlan, setUserPlan] = useState();
  const handleChangeTab = (_: React.SyntheticEvent, newValue: number): void => {
    setTab(newValue);
  };

  useEffect(() => {
    if (id) {
      getUserPlan(id)
        .then(({ basicInfo }) => {
          setUserPlan(basicInfo);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id]);
  const styles = {
    userPlanBox: {
      maxWidth: {
        xs: 320,
        sm: 480,
        md: '100%',
      },
      borderRadius: 3,
      p: 2,
      mb: 2,
      boxShadow: 2,
      bgcolor: 'background.paper',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    userPlanText: {
      display: 'flex',
      alignItems: 'center',
    },
    userPlanTypho: {
      marginBlock: 2,
      color: colors.greenAccent[500],
      fontWeight: 800,
      fontSize: 18,
      fontFamily: 'Inter !important',
    },
    tabsMainBox: {
      maxWidth: {
        xs: 320,
        sm: 480,
        md: '100%',
      },
      borderRadius: 3,
      px: 2,
      boxShadow: 2,
      bgcolor: 'background.paper',
    },
    tabsStyles: {
      '& .MuiTab-root.Mui-selected': {
        color: colors.greenAccent[500],
      },
    },
  };
  return (
    <Box>
      <Box sx={styles.userPlanBox}>
        <Box sx={styles.userPlanText}>
          <Typography component="h5" variant="h5" sx={styles.userPlanTypho}>
            {strings.displayText.pensionPlan} :
          </Typography>
          <Typography
            component="h5"
            variant="h5"
            color={colors.gray[100]}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
            ml={1}
            mr={2}
          >
            {userPlan?.pensionPlanName || '-'}
          </Typography>
          <Typography component="h5" variant="h5" sx={styles.userPlanTypho}>
            {strings.displayText.retirementOption} :
          </Typography>
          <Typography
            component="h5"
            variant="h5"
            color={colors.gray[100]}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
            ml={1}
            mr={40}
          >
            {userPlan?.planName || '-'}
          </Typography>
        </Box>
        <Box sx={styles.userPlanText}>
          <Typography component="h5" variant="h5" sx={styles.userPlanTypho}>
            {strings.displayText.vested} :
          </Typography>
          <Typography
            component="h5"
            variant="h5"
            color={colors.gray[100]}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
            ml={1}
            mr={2}
          >
            {userPlan?.isAccountVested ? 'Yes' : 'No'}
          </Typography>
          <Typography component="h5" variant="h5" sx={styles.userPlanTypho}>
            {strings.displayText.avc} :
          </Typography>
          <Typography
            component="h5"
            variant="h5"
            color={colors.gray[100]}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
            ml={1}
          >
            {userPlan?.isUserAVC ? 'Yes' : 'No'}
          </Typography>
        </Box>
      </Box>
      <Box sx={styles.tabsMainBox}>
        <Box>
          <Tabs
            value={tab}
            onChange={handleChangeTab}
            variant="scrollable"
            indicatorColor="secondary"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: colors.greenAccent[600],
              },
            }}
            sx={styles.tabsStyles}
          >
            <Tab label={strings.displayText.planChangeRequestsLabel} />
            <Tab label={strings.displayText.withdrawalRequestsLabel} />
          </Tabs>
        </Box>
        <TabPanel value={tab} index={0}>
          <UserPlanChangeRequests />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <UserWithdrawalRequests />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default PlanDetails;
